import "./Services.module.css";
import Navigation from "@/reusable_sections/Header";
import ElevateYourApplication from "./sections/ElevateYourApplication";
import TheEnlightenEdge from "./sections/TheEnlightenEdge";
import CollaborationFaqs from "./sections/CollaborationFaqs";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Navigation />
      <ElevateYourApplication />
      <TheEnlightenEdge />
      <CollaborationFaqs />
      <Footer />
    </div>;
}